import CompanyCategoriesDocumentMainPage from './main';
import CompanyCategoryDocumentEdit from './edit';
import SingleCompanyCategoryDocument from './singleCategory';

const routes = [
  {
    path: '/*',
    Component: CompanyCategoriesDocumentMainPage,
    props: {},
  },
  {
    path: '/:id/edit',
    Component: CompanyCategoryDocumentEdit,
    props: {},
  },
  {
    path: '/:id',
    Component: SingleCompanyCategoryDocument,
    props: {},
  },
  {
    path: '/new',
    Component: CompanyCategoryDocumentEdit,
    props: {
      isNew: true,
    },
  },
];

export default routes;
